import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

const InteractionProspectsModelSchema = z
  .object({
    id: z.string(),
    interaction_id: z.string().nullish(),
    prospect_id: z.string().nullish()
  })
  .strict()

export const InteractionProspectsModelFields = makeFieldKeys(InteractionProspectsModelSchema)

export type InteractionProspectsModel = z.infer<typeof InteractionProspectsModelSchema>

function validateInteractionProspectsModel(data: unknown): InteractionProspectsModel {
  try {
    return validateWithZodSchema(InteractionProspectsModelSchema, data, 'interaction prospects model')
  } catch (error) {
    throw new Error(`Interaction prospects model validation failed: ${error}`)
  }
}
